/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const DashbaordQueryKeys = {
  all: ['user'] as const,
  lists: () => [...DashbaordQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...DashbaordQueryKeys.lists(), { filters }] as const,
  details: () => [...DashbaordQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...DashbaordQueryKeys.details(), id] as const,
};
